import { Injectable,signal } from '@angular/core';
import { ToastMessage, ToastType } from '../../../models/toast.types';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
// A reactive list array storing all active visible alerts
  toasts = signal<ToastMessage[]>([]);
  private counter = 0;

  show(message: string, type: ToastType = 'info', duration = 4000): void {
    const id = this.counter++;
    const newToast: ToastMessage = { id, message, type };

    // Append the new alert to our state array signal
    this.toasts.update(currentToasts => [...currentToasts, newToast]);

    // Automatically remove the toast after the duration timer expires
    setTimeout(() => {
      this.remove(id);
    }, duration);
  }

  showSuccess(message: string, duration?: number): void {
    this.show(message, 'success', duration);
  }

  showError(message: string, duration?: number): void {
    this.show(message, 'error', duration);
  }

  showInfo(message: string, duration?: number): void {
    this.show(message, 'info', duration);
  }

  showWarning(message: string, duration?: number): void {
    this.show(message, 'warning', duration);
  }

  remove(id: number): void {
    this.toasts.update(currentToasts => currentToasts.filter(t => t.id !== id));
  }
}
